var _path, _path2, _line, _line2, _line3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorRoom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m5.736,29.485V12.787c0-1.617.906-3.097,2.346-3.832l10.961-5.6c1.23-.628,2.686-.628,3.915,0l10.961,5.6c1.44.735,2.346,2.216,2.346,3.832v16.698"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m36.264,12.515v16.698c0,1.617-.906,3.097-2.346,3.832l-10.961,5.6c-1.23.628-2.686.628-3.915,0l-10.961-5.6c-1.44-.735-2.346-2.216-2.346-3.832V12.515"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 21.012,
    y1: 22.294,
    x2: 21.012,
    y2: 11.041
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 30.758,
    y1: 27.92,
    x2: 21.012,
    y2: 22.294
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 20.988,
    y1: 22.308,
    x2: 11.242,
    y2: 27.934
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorRoom);
export default __webpack_public_path__ + "static/media/indoor-room.63357724c342f635d02f97a1db3ab910.svg";
export { ForwardRef as ReactComponent };